// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p{
    font-size: 1.75em;
    font-weight: bold;
}

.message {
    padding: 50px;
}


.browse:hover {
    background-color:#666 !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/features/download-upload-flatfile/download-upload-flatfile.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,gCAAgC;EAClC","sourcesContent":["p{\r\n    font-size: 1.75em;\r\n    font-weight: bold;\r\n}\r\n\r\n.message {\r\n    padding: 50px;\r\n}\r\n\r\n\r\n.browse:hover {\r\n    background-color:#666 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
